jQuery(document).ready(function($) {
	$(".key-figures-boxes .slider-wrapper").slick({
		infinite: false,
		slidesToShow: 3,
		arrows: true,
		nextArrow: ".next-wrapper",
		prevArrow: ".prev-wrapper",
		responsive: [
			{
				breakpoint: 1098,
				settings: {
				slidesToShow: 2,
				arrows: false,
				dots: true,
				appendDots: ".slider-dots"
				}
			},
			{
				breakpoint: 768,
				settings: {
				slidesToShow: 1,
				arrows: false,
				dots: true,
				appendDots: ".slider-dots"
				}
			}
		]
	});
});